import { GeolocationAdapterReturn } from '../types/adapters'
import { Capacitor } from '@capacitor/core'
import { backgroundGeolocationAdapter } from './backgroundGeolocation'
import { geolocationAdapter } from './geolocation'

export const selectGeolocationAdapter = (): GeolocationAdapterReturn => {
  if (!Capacitor.isNativePlatform()) {
    const adapter = geolocationAdapter()
    return adapter
  } else {
    return backgroundGeolocationAdapter()
  }
}
